import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { utc_to_eet } from "../../utilities/formatters";
import { dollarUS } from "../../utilities/formatters";
import { useSelector } from "react-redux";

const BalanceChart = ({ PerformanceChart }) => {
  const { theme } = useSelector((state) => state.theme);

  const [series, setSeries] = useState([
    {
      name: "Equity",
      type: "area",
      data: [],
    },
    {
      name: "Balance",
      type: "area",
      data: [],
    },
  ]);

  const options = {
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: theme === "light" ? "white" : "black",
      },
      markers: {
        width: 10,
        height: 10,
      },
    },
    colors: theme !== "light" ? ["#FD504F", "#0082AB"] :  ["#FD504F", "#36F8EC"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      color: "#FFF",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "area",
      zoom: {
        enabled: true,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    labels:
      PerformanceChart &&
      Object.keys(PerformanceChart).map((data) =>
        utc_to_eet(PerformanceChart[data].time)
      ),
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: true,
        style: {
          colors: theme === "light" ? "#8B8E93" : "#000000",
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      type: "numeric",
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
          color: "#FFF",
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "14px",
        fontWeight: "700",
        color: "#FFF",
      },
      x: {
        show: true,
        formatter: (val) => {
          const date = new Date(val);
          return `${date.toDateString()} ${date.toLocaleTimeString()}`;
        },
      },
    },
  };

  useEffect(() => {
    let balancedata =
      PerformanceChart &&
      Object.keys(PerformanceChart).map(
        (data) => PerformanceChart[data].balance
      );
    let equitydata =
      PerformanceChart &&
      Object.keys(PerformanceChart).map(
        (data) => PerformanceChart[data].equity
      );

    setSeries([
      {
        name: "Equity",
        data: equitydata || [],
      },
      {
        name: "Balance",
        data: balancedata || [],
      },
    ]);

  }, [PerformanceChart]);

  return (
    <div id="chart">
      <ReactApexChart options={options} series={series} type="area" height={290} />
    </div>
  );
};
export default BalanceChart;
